import { useState } from "react";
import ManIcon from "assets/icons/man.webp";
import Toggle from "components/toggle";
import styles from "./style.module.scss";
import { useKeycloak } from "@react-keycloak/web";

interface IProps {
  title: string;
  background?: string;
  color?: string;

  settingsIcon: any;

  chatIcon: any;

  announcementIcon: any;

  hamburgerIcon: any;

  personal: string;
}

const HomeHeader = ({
  title,
  background,
  color,
  settingsIcon,
  chatIcon,
  announcementIcon,
  hamburgerIcon,
  personal,
}: IProps) => {
  const [toggle, setToggle] = useState(false);
  const handleOpenToggle = () => setToggle(!toggle);
  const { keycloak } = useKeycloak();

  return (
    <div
      style={{
        background: `url(${background})`,
        color: `${color}`,
      }}
      className={styles.header}
      >
        
      <div className={styles.top}>
        <div className={styles.list}>
          <div className={styles.topIcon}>
            <div className={styles.topLeft}>
              <div
                style={{
                  color: `${color}`,
                }}
                className={styles.text}
              >
                <b>Hoşgeldin, </b>
                {keycloak?.tokenParsed?.name} 
              </div>
            </div>
            <div className={styles.topRight}>
              <div className={styles.profileCard}>
                <div className={styles.toggle} onClick={handleOpenToggle}>
                  <img src={hamburgerIcon} alt="icon" />
                </div>
               
              </div>
              <div className={styles.profile}>
                <div className={styles.personal}>
                  <div
                    style={{
                      color: `${personal}`,
                    }}
                  >
                   {keycloak?.tokenParsed?.preferred_username}
                  </div>
                  <span
                    className="logout"
                    style={{
                      color: `${personal}`,
                    }}
                    onClick={() => { 
                      keycloak.logout(); 
                      window.localStorage.setItem('userUID', '');
                      window.localStorage.setItem('id_token', '');
                      window.localStorage.setItem('userName', '');
                      window.localStorage.setItem('userDisplay', 'none') }}
                  >
                    Çıkış Yap
                  </span>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className={styles.bottom}>
        <b>{title}</b>
      </div>



      <Toggle toggle={toggle} handleOpenToggle={handleOpenToggle} />
    </div>
  );
};

export default HomeHeader;
